export const CALL_TRANSFER_FILTER_SELECTED_STORAGE_KEY = 'CallTransferFilterSelected';
export const GROUP_NAME_FILTER_SELECTED_STORAGE_KEY = 'GroupNameFiltersSelected';
export const SOURCE_FILTERS_STORAGE_KEY = 'SourceFiltersSelected';
